<div class="profile-shell">
  <section class="profile-hero">
    <div class="profile-hero__cover"></div>
    <div class="profile-hero__content">
      <div class="identity-card">
        <div class="identity-card__media">
          <img
            class="identity-card__avatar"
            [src]="data?.profilePic || 'assets/images/man.png'"
            alt="Profile picture"
          />
        </div>
        <div class="identity-card__copy">
          <h1>{{ (data?.firstName || '') + (data?.lastName ? ' ' + data?.lastName : '') || 'Guest User' }}</h1>
          <p>{{ data?.email || 'No email provided' }}</p>
          <div class="pill-group">
            <span class="pill pill-primary" *ngIf="data?.userType">{{ data?.userType | titlecase }}</span>
            <span class="pill pill-soft" *ngIf="data?.city || displayCountry">
              {{ data?.city || '-' }}, {{ displayCountry || '-' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="profile-details-card">
    <div class="details-header">
      <div>
        <p class="eyebrow-text">Customer Center</p>
        <h2>My Profile</h2>
      </div>
      <span class="badge-live">Active</span>
    </div>

    <div class="detail-section">
      <div class="section-heading">
        <h3>Personal Information</h3>
        <p>Review key details linked with your account.</p>
      </div>

      <div class="detail-grid">
        <article class="detail-tile">
          <span>Full Name</span>
          <p>{{ (data?.firstName || '-') + (data?.lastName ? ' ' + data?.lastName : '') }}</p>
        </article>
        <article class="detail-tile">
          <span>Email Address</span>
          <p>{{ data?.email || '-' }}</p>
        </article>
        <article class="detail-tile">
          <span>Mobile Number</span>
          <p>{{ getMobileNumberWithCode(data?.countryCode, data?.mobileNumber) || '-' }}</p>
        </article>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-heading">
        <h3>Address Information</h3>
        <p>The primary address saved with your profile.</p>
      </div>

      <div class="detail-grid">
        <article class="detail-tile detail-tile--full">
          <span>Address</span>
          <p>
            {{ data?.addressLine1 || '-' }}
            <ng-container *ngIf="data?.addressLine2">
              , {{ data?.addressLine2 }}
            </ng-container>
          </p>
        </article>
        <article class="detail-tile">
          <span>Country</span>
          <p>{{ displayCountry || data?.country || '-' }}</p>
        </article>
        <article class="detail-tile">
          <span>State</span>
          <p>{{ displayState || data?.state || '-' }}</p>
        </article>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-heading">
        <h3>Location Details</h3>
        <p>Used for communication and deliveries.</p>
      </div>

      <div class="detail-grid">
        <article class="detail-tile">
          <span>City</span>
          <p>{{ data?.city || '-' }}</p>
        </article>
        <article class="detail-tile">
          <span>Zip Code</span>
          <p>{{ data?.zipCode || '-' }}</p>
        </article>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-heading">
        <h3>Account & Access</h3>
        <p>Security-friendly shortcuts to share or copy.</p>
      </div>

      <div class="detail-grid">
        <article class="detail-tile detail-tile--interactive">
          <span>Wallet Address</span>
          <p (click)="copyText(data?.walletAddress)" title="Click to copy wallet address">
            {{ data?.walletAddress || '-' }}
          </p>
          <button
            class="icon-button"
            type="button"
            *ngIf="data?.walletAddress"
            (click)="copyText(data?.walletAddress)"
            title="Copy wallet address"
          >
            <i class="fa fa-copy"></i>
          </button>
        </article>
        <article class="detail-tile detail-tile--interactive">
          <span>Referral Code</span>
          <p (click)="copyText(data?.refferalCode)" title="Click to copy referral code">
            {{ data?.refferalCode || '-' }}
          </p>
          <button
            class="icon-button"
            type="button"
            *ngIf="data?.refferalCode"
            (click)="copyText(data?.refferalCode)"
            title="Copy referral code"
          >
            <i class="fa fa-copy"></i>
          </button>
        </article>
      </div>
    </div>

    <div class="detail-section">
      <div class="section-heading">
        <h3>Quick Actions</h3>
        <p>Manage your account without leaving this screen.</p>
      </div>

      <div class="profile-actions">
        <a class="action-chip" routerLink="/edit-customer-profile">
          <i class="fa fa-edit"></i>
          Edit Profile
        </a>
        <a class="action-chip" routerLink="/change-password-customer">
          <i class="fa fa-lock"></i>
          Change Password
        </a>
        <a class="action-chip action-chip--danger" (click)="showDeleteAccountModal()">
          <i class="fa fa-trash"></i>
          Delete Account
        </a>

        <ng-container *ngIf="data?.userType != 'CUSTOMER' && data?.userType == 'RETAILER'">
          <a class="action-chip" routerLink="/edit-business-form">
            <i class="fa fa-file-text"></i>
            Edit Business Document
          </a>
        </ng-container>

        <ng-container *ngIf="data?.userType != 'CUSTOMER' && data?.userType == 'SERVICE_PROVIDER'">
          <a class="action-chip" routerLink="/edit-business-detail-service">
            <i class="fa fa-file-text"></i>
            Edit Business Document
          </a>
        </ng-container>
      </div>
    </div>
  </section>
</div>

<!-- Delete Account Modal -->
<div class="modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <button type="button" class="close-btn" (click)="closeDeleteModal()">
        <span>&times;</span>
      </button>
    </div>
    
         <div class="modal-body text-center">
       <div class="warning-icon">
         <i class="fa fa-exclamation-triangle"></i>
       </div>
       
       <h2 class="modal-title">Are you sure you want to delete your account?</h2>
       
       <p class="warning-text">
         This action cannot be undone. All your data, including profile information, order history, wallet balance, saved addresses, and wishlist items will be permanently deleted.
       </p>
     </div>
    
    <div class="modal-footer d-flex justify-content-center mb-4">
      <button type="button" class="btn btntt1" (click)="closeDeleteModal()">
        No
      </button>
      <button type="button" class="btn btntt ml-3" (click)="confirmDeleteAccount()">
        Yes
      </button>
    </div>
  </div>
</div>